import {$clientApi} from "../http";
import {ICustomerSubscription} from "../models/CustomerSubscription";


class ClientSubscriptionServiceClass {

    async getCustomerSubscriptions(customerId: number) {
        return  $clientApi.get<ICustomerSubscription[]>(`api/customers/subscriptions/${customerId}`);
    }

    async finishAutoRenewalSubscription(subscriptionId: number) {
        return  $clientApi.post("api/subscriptions/stop-auto-renewal", {subscriptionId})
    }

}

export const ClientSubscriptionService = new ClientSubscriptionServiceClass();